import { Disclosure } from "@headlessui/react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store/store";
import RenderText from "../ReUsableComponents/RenderText";
import { LuArrowUpFromLine } from "react-icons/lu";

const Explanation = () => {
  const { currentQuestion } = useSelector(
    (state: RootState) => state.root.resultsSlice
  );

  const { completedTestData, qId } = useSelector(
    (state: RootState) => state.root.startFullTest
  );
  const questionData = completedTestData?.additionalProps?.overallresult?.[
    currentQuestion
  ]?.find((q: any) => q._id === qId);

  return (
    <div>
      <Disclosure defaultOpen>
        {({ open }) => (
          <div>
            <div className="flex items-center justify-between text-satPrepAccent">
              <h3 className="text-lg font-medium">Explanation</h3>
              <Disclosure.Button className="flex items-center space-x-2 text-satPrepAccent">
                <LuArrowUpFromLine size={22} />
              </Disclosure.Button>
            </div>

            <Disclosure.Panel>
              <div className="py-2 rounded-xl leading-[21.6px]">
                <RenderText
                  text={questionData?.explanation}
                  imageDetails={questionData}
                  isOptions={false}
                  questionId={questionData?._id}
                  contentType="explanation"
                />
              </div>
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    </div>
  );
};

export default Explanation;
